var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.362,
    height: 11.156,
    viewBox: "0 0 16.362 11.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qQcTQQ",
    transform: "translate(-1134.498 -102.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(1134.498 102.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1136.89,107.657h13.231a.665.665,0,0,1,.739.666.679.679,0,0,1-.746.686q-4.236,0-8.472,0h-4.762c0,.089.064.114.1.152q1.739,1.742,3.481,3.482a.855.855,0,0,1,.277.421.679.679,0,0,1-1.159.625c-.5-.488-.986-.982-1.478-1.475l-3.271-3.273a.726.726,0,0,1,0-1.225q2.34-2.339,4.678-4.681a.759.759,0,0,1,.6-.281.638.638,0,0,1,.592.419.659.659,0,0,1-.15.746q-1.167,1.173-2.34,2.34c-.45.449-.9.894-1.355,1.341Z",
    transform: "translate(-1134.498 -102.753)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.da7704570c5bfd039b6f18661c8175aa.svg";
export { ForwardRef as ReactComponent };